import { NavigationMenuItem } from '../../models/NavigationMenuItem';
import { B2B_URL } from './constans';

export const SIDEBAR_PROFILE_NAVIGATION: NavigationMenuItem = {
    id: 'sidebar-menu',
    resourceId: null,
    title: null,
    type: null,
    url: null,
    items: [
        {
            id: 'profile',
            resourceId: null,
            title: 'NAVIGATION_GROUP.PROFILE.TITLE',
            translateTitle: true,
            type: 'GROUP',
            url: null,
            items: [
                {
                    id: 'profile',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.PROFILE.ITEMS.EDIT_PROFILE',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/profile',
                },
                {
                    id: 'account',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.PROFILE.ITEMS.ORDERS',
                    translateTitle: true,
                    type: 'PAGE',
                    url: B2B_URL + '/account',
                },
                {
                    id: 'invoices',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.PROFILE.ITEMS.INVOICES',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/invoices',
                },
                {
                    id: 'shipments',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.PROFILE.ITEMS.DELIVERY_NOTES',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/shipments',
                },
                {
                    id: 'live_orders',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.PROFILE.ITEMS.LIVE_ORDERS',
                    translateTitle: true,
                    showOnlyOnMobile: false,
                    type: 'ROUTE',
                    url: '/live-orders',
                },
                {
                    id: 'document-library',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.PROFILE.ITEMS.DOCUMENTS',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/document-library',
                },
                {
                    id: 'refund',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.PROFILE.ITEMS.REFUND',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/refund',
                },
                /*{
                    id: 'shop',
                    resourceId: null,
                    title: 'HEADER.SHOP',
                    translateTitle: true,
                    showOnlyOnMobile: true,
                    type: 'PAGE',
                    url: B2B_URL,
                },*/
                {
                    id: 'logout',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.PROFILE.ITEMS.LOGOUT',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/logout',
                    color: '#C12F3B',
                },
            ],
        },
        {
            id: 'quotations',
            resourceId: null,
            title: 'NAVIGATION_GROUP.QUOTATIONS.TITLE',
            url: null,
            type: 'GROUP',
            items: [
                {
                    id: 'quotations',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.QUOTATIONS.ITEMS.QUOTE_OFFERS',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/quotations',
                },
                {
                    id: 'my-quotations',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.QUOTATIONS.ITEMS.QUOTE_REQUESTS',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/my-quotations',
                },
                {
                    id: 'comment-templates',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.PROFILE.ITEMS.COMMENT_TEMPLATES',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/comment-templates',
                },
            ],
        },
    ],
};

export const SIDEBAR_ADMIN_NAVIGATION: NavigationMenuItem = {
    id: 'admin-menu',
    resourceId: null,
    title: null,
    type: null,
    url: null,
    items: [
        {
            id: 'admin',
            resourceId: null,
            title: 'NAVIGATION_GROUP.ADMIN.TITLE',
            type: 'GROUP',
            url: null,
            items: [
                {
                    id: 'users',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.ADMIN.ITEMS.USERS',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/admin/users',
                },
                {
                    id: 'add-partner',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.ADMIN.ITEMS.ADD_BC_PARTNER',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/admin/add-partner',
                },
                {
                    id: 'products-management',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.ADMIN.ITEMS.PRODUCT_MANAGEMENT',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/admin/products-management',
                },
                {
                    id: 'document-library',
                    resourceId: null,
                    title: 'NAVIGATION_GROUP.ADMIN.ITEMS.DOCUMENTS',
                    translateTitle: true,
                    type: 'ROUTE',
                    url: '/admin/document-library',
                },
            ],
        },
    ],
};
